import { render, staticRenderFns } from "./InspectorSuer.vue?vue&type=template&id=194976a6&scoped=true&"
import script from "./InspectorSuer.vue?vue&type=script&lang=js&"
export * from "./InspectorSuer.vue?vue&type=script&lang=js&"
import style0 from "./InspectorSuer.vue?vue&type=style&index=0&id=194976a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194976a6",
  null
  
)

export default component.exports